/**
 * Opens a new browser window with a loading spinner.
 * Used to avoid popup blockers while fetching files asynchronously.
 * 
 * @param title - The title to display in the browser tab
 * @param loadingText - Optional custom loading text (defaults to "Loading document...")
 * @returns The opened window object, or null if popup was blocked
 */
export const showLoadingWindow = (
  title: string,
  loadingText: string,
): Window | null => {
  const newWindow = window.open('about:blank', '_blank');
  if (newWindow) {
    newWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${title}</title>
          <style>
            body {
              margin: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              background: #f5f5f5;
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            }
            .loader-container {
              text-align: center;
            }
            .spinner {
              width: 50px;
              height: 50px;
              border: 4px solid #e0e0e0;
              border-top: 4px solid #1890ff;
              border-radius: 50%;
              animation: spin 1s linear infinite;
              margin: 0 auto 16px;
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            .loading-text {
              color: #666;
              font-size: 16px;
            }
          </style>
        </head>
        <body>
          <div class="loader-container">
            <div class="spinner"></div>
            <div class="loading-text">${loadingText}</div>
          </div>
        </body>
      </html>
    `);
    newWindow.document.close();
  }
  return newWindow;
};

